import { useState } from "react";

interface NotificationState {
  open: boolean;
  message: string;
  severity: "success" | "error";
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: "",
    severity: "success"
  });

  const showNotification = (message: string, severity: "success" | "error" = "error") => {
    setNotification({ open: true, message, severity });
  };

  const hideNotification = () => {
    setNotification(prev => ({ ...prev, open: false }));
  };

  return {
    notification,
    showNotification,
    hideNotification
  };
};
